module.exports = __webpack_public_path__ + "img/Spain.31a7c511.png";